<template>
  <div class="dashboard-panel p-overview">
    <div>
      <div class="panel-header">
        <h2>Overview</h2>

        <div class="info-wrapper">
          <div>
            <label>Leads</label>
            <h3>{{ totalLeads }}</h3>
          </div>
          <div>
            <label>Hot Leads</label>
            <h3>{{ totalHotLeads }}</h3>
          </div>
          <div>
            <label>Loans Funded</label>
            <h3>{{ totalLoansFunded | currency }}</h3>
          </div>
        </div>
      </div>
      <div class="panel-content">
        <div class="year-label">{{ yearLabel }}</div>

        <Graph
          v-if="!loading && matches.length"
          id="chart-overview"
          :chartData="graphData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Graph from './Graph'

export default {
  name: 'PanelOverview',
  components: {
    Graph,
  },
  props: {
    matches: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    loading: true,
    graphData: {},
  }),
  computed: {
    totalLeads () {
      return (this.matches || []).length
    },

    totalHotLeads () {
      return (this.matches || [])
        .filter(({ contactedAt }) => !!contactedAt)
        .length
    },

    totalLoansFunded () {
      return (this.matches || [])
        .filter(({ status }) => status === 'Funded')
        .reduce((sum, { deal }) => sum + Number(deal.dealSize), 0)
    },

    yearLabel () {
      const lastYear = moment().subtract(1, 'year').format('MMM YYYY')
      const thisYear = moment().format('MMM YYYY')
      return `Year: ${lastYear} - ${thisYear}`
    },
  },

  watch: {
    matches () { this.buildGraphData() },
  },

  mounted () {
    this.buildGraphData()
  },

  methods: {
    buildGraphData () {
      if (!this.matches || !this.matches.length) return

      this.loading = true

      const data = []

      for (let i = 12; i >= 0; i--) {
        data.push({
          x: moment().subtract(i, 'months'),
          y: 0,
        })
      }

      for (const match of this.matches) {
        const index = moment(match.createdAt).diff(moment(), 'months') + 12
        if (index < 0 || index > 12) continue
        data[index].y += 1
      }

      this.graphData = {
        datasets: [{
          barPercentage: 0.5,
          minBarLength: 10,
          backgroundColor: '#0096A6',
          data,
        }],
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-panel {
  & > div {
    width: 100%;
    background-color: transparent !important;
    border: none !important;
  }

  .panel-header {
    padding: 0 35px;
    flex-direction: column;
  }

  .panel-content {
    padding: 30px;
  }

  .info-wrapper {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    padding-left: 30px;

    div {
      text-align: left;
      flex-grow: 0;

      padding-right: 50px;
      @include lg { padding-right: 100px; }

      label {
        color: $textGrey;
        font-family: "Avenir Heavy", sans-serif;
        font-size: 14px;
      }

      h3 {
        color: $accentBlue;
        font-family: "Sansation Bold", sans-serif;
        font-size: 36px;
        line-height: 42px;
      }
    }
  }

  .year-label {
    display: flex;
    justify-content: flex-end;

    font-size: 15px;
  }
}
</style>
